import { Injectable } from '@angular/core';

import { DataEntry } from '@osos/shared/api';
import { UserModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { UserParserV1Service } from '../../parsers/user-pareser/user-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable()
export class UserFactoryService extends FactoryBase<DataEntry, UserModel> {
  constructor(parserFactory: ParserFactory, parser_v1: UserParserV1Service) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: UserModel): DataEntry {
    const parser = this.getParser(
      DataEntry,
      UserModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: DataEntry): UserModel {
    const parser = this.getParser(
      DataEntry,
      UserModel,
      model.specificationVersion,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
